import { Edit, useForm } from '@refinedev/antd'
import { useParams, useNavigate } from 'react-router-dom'
import { Form } from 'antd'
import { ProductFormFields } from './ProductFormFields'

export default function ProductEditPage() {
  const { id } = useParams()
  const navigate = useNavigate()

  const { formProps, saveButtonProps } = useForm({
    resource: 'products',
    action: 'edit',
    id,
    redirect: false,
    onMutationSuccess: () => {
      navigate(`/products/${id}`)
    },
  })

  return (
    <Edit title="Izmeni proizvod" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <ProductFormFields />
      </Form>
    </Edit>
  )
}
